/** @jsx jsx */
import { Box, Flex, Grid, Heading, jsx } from 'theme-ui'
import { GatsbyImage } from 'gatsby-plugin-image'
import CallToAction from '~/components/Content/Section/CallToAction'

const PromoCard = ({ cta, description, image, title }) => {
  return (
    <Box bg="white">
      <Grid columns={[1, 2]} sx={{ rowGap: '0' }}>
        <Box>
          <GatsbyImage image={image.gatsbyImageData} alt={image.description} />
        </Box>
        <Flex
          pl={[3, 0]}
          pr={3}
          py={3}
          sx={{ flexDirection: 'column', justifyContent: 'center' }}
        >
          <Heading as="h2" variant="title3" mb={2}>
            {title}
          </Heading>
          {description && (
            <Box
              variant={'text.body2'}
              sx={{ p: { m: 0 } }}
              dangerouslySetInnerHTML={{
                __html: description.childMarkdownRemark.html,
              }}
            />
          )}
          {cta && (
            <Box mt={4}>
              <CallToAction content={cta} />
            </Box>
          )}
        </Flex>
      </Grid>
    </Box>
  )
}

export default PromoCard
